<template>
  <div class="acomodar container-fluid py-3 px-4">
    <!-- Botón Retroceder -->
    <div class="mb-3">
      <button class="btn btn-outline-danger btn-sm shadow-sm" @click="$router.go(-1)">
        <i class="bi bi-arrow-left-circle me-1"></i> VOLVER AL LISTADO
      </button>
    </div>

    <!-- Encabezado -->
    <div class="border border-1 rounded-3 p-3 mb-3 bg-white shadow-sm">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-cash-stack display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            GESTIÓN DE DESCUENTOS
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            DETALLE DEL DESCUENTO
          </p>
        </div>
      </div>
    </div>

    <!-- Datos del Trabajador -->
    <div class="card border-0 border-start border-4 border-primary shadow-sm mb-4">
      <div class="card-body p-4">
        <h5 class="fw-bold text-primary mb-3">
          <i class="bi bi-person-badge-fill me-2"></i>DATOS DEL TRABAJADOR
        </h5>
        <div class="row gx-4 gy-3 text-start">
        <div class="col-lg-4 col-md-6">
          <label class="color small mb-0">CC:</label>
          <p class="fw-bold mb-0">{{ centro }}</p>
        </div>

        <div class="col-lg-4 col-md-6">
          <label class="color small mb-0">SCC:</label>
          <p class="fw-bold mb-0">{{ subCentro }}</p>
        </div>

        <div class="col-lg-4 col-md-6">
          <label class="color small mb-0">SSCC:</label>
          <p class="fw-bold mb-0">{{ subSubCentro }}</p>
        </div>

        <div class="col-lg-4 col-md-6">
          <label class="color small mb-0">NOMBRE Y APELLIDOS:</label>
          <p class="fw-bold mb-0">{{ nombre }}</p>
        </div>
        <div class="col-lg-4 col-md-6">
          <label class="color small mb-0">DOC. IDENTIDAD:</label>
          <p class="fw-bold mb-0">{{ documentos }}</p>
        </div>

        <div class="col-lg-4 col-md-6">
          <label class="color small mb-0">PERIODO:</label>
          <p class="fw-bold mb-0">{{ periodo }}</p>
        </div>
        </div>
      </div>
    </div>

    <form
      v-if="idPerfilUsuario == 5 || idPerfilUsuario == 10 || idPerfilUsuario == 7 || idPerfilUsuario == 15 || idPerfilUsuario    == 16"
      @submit.prevent="Insertar"
    >
      <div class="border border-1 rounded-3 p-4 mb-4 bg-white shadow-sm">
        <h5 class="fw-bold text-success mb-4">
          <i class="bi bi-plus-circle-fill me-2"></i>REGISTRAR NUEVO DESCUENTO
        </h5>
        <div class="row gy-3">
          <div class="col-md-6">
            <label class="tamaño mb-1">CONCEPTO:</label>
          <select
            v-model="conceptoIndex"
            required
            class="form-select w-100"
            aria-label="Default select example"
            @change="SelectorOptions"
          >
            <option value="" disabled selected>seleccionar</option>
            <option
              v-for="(items, index) in paramsTecnologia"
              :key="index.id"
              :value="index"
            >
              {{ items.parDescripcion }}
            </option>
          </select>
        </div>
          <div class="col-md-3">
            <label class="tamaño mb-1">MONTO:</label>
          <input
            type="number"
            class="form-control"
            id="exampleFormControlInput1"
            placeholder=""
            v-model="monto"
            required
            @input="limitarDigitos"
          />
        </div>

          <div class="col-md-3">
            <label class="tamaño mb-1">CUOTAS:</label>
          <input
            type="number"
            class="form-control"
            id="exampleFormControlInput1"
            placeholder=""
            v-model="cuotas"
            required
            @input="limitarDigitos"
          />
        </div>

        <div class="col-12">
            <div class="form-group">
              <label class="tamaño mb-1" for="exampleFormControlTextarea1">DESCRIPCIÓN (Max. 240 caracteres):</label>
            <textarea
              v-model="descripcion"
              class="form-control"
              id="exampleFormControlTextarea1"
              required
              @input="limitarDigitos"
            ></textarea>
          </div>
        </div>

          <div class="col-12 text-center mt-3">
            <button class="btn btn-success px-5 shadow-sm" type="submit">
              <i class="bi bi-plus-lg me-1"></i> AGREGAR DESCUENTO
            </button>
          </div>
        </div>
      </div>
    </form>

    <div class="modal" v-if="editar">
      <div class="modal-content">
        <h1 class="mt-3">EDITAR DESCUENTO</h1>
        <div class="row gx-3 gy-3 mb-4">
          <div class="form-group col-8" style="text-align: left">
            <label class="" for="exampleFormControlInput1">Concepto:</label>
            <select
              required
              class="form-select text-center"
              aria-label="Default select example"
              @change="SelectorOptionsModal($event)"
            >
              <option selected disabled>{{ nombreSeleccionado }}</option>
              <option
                v-for="(items, index) in paramsTecnologia"
                :key="index.id"
                :value="index"
              >
                {{ items.parDescripcion }}
              </option>
            </select>
          </div>

          <div class="form-group col-2" style="text-align: left">
            <label style="text-align: left" for="exampleFormControlInput1"
              >Monto:</label
            >
            <input
              type="text"
              class="form-control"
              id="exampleFormControlInput1"
              placeholder=""
              required
              v-model="montoModal"
              @input="limitarDigitos"
            />
          </div>

          <div class="form-group col-2" style="text-align: left">
            <label style="text-align: left" for="exampleFormControlInput1"
              >Cuotas:</label
            >
            <input
              type="text"
              class="form-control"
              id="exampleFormControlInput1"
              required
              placeholder=""
              v-model="cuotasModal"
              @input="limitarDigitos"
            />
          </div>

          <div class="form-group col-12" style="text-align: left">
            <label style="text-align: left" for="exampleFormControlInput1"
              >Descripción</label
            >
            <textarea
              class="form-control"
              required
              id="exampleFormControlTextarea1"
              v-model="descripcionModal"
              @input="limitarDigitos"
            ></textarea>
          </div>
        </div>

        <div class="row mt-4 gap-2 justify-content-center">
          <div class="col-auto">
            <button class="btn btn-success px-4" @click="GuardarModificacion">
              <i class="bi bi-check-circle me-1"></i> GUARDAR CAMBIOS
            </button>
          </div>
          <div class="col-auto" @click="editar = false">
            <button class="btn btn-secondary px-4">CERRAR</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Listado de Descuentos -->
    <div class="border border-1 rounded-3 p-3 bg-white shadow-sm table-responsive">
      <h5 class="fw-bold text-primary mb-3">
        <i class="bi bi-list-ul me-2"></i>HISTORIAL DE DESCUENTOS
      </h5>
      <table class="table table-bordered">
        <thead class="reducirTamaño">
          <tr class="text-nowrap text-white bg-solimano text-center">
            <th v-if="idPerfilUsuario == 5">ACCIÓN</th>
            <th scope="col">CONCEPTO</th>
            <th scope="col">DESCRIPCIÓN</th>
            <th scope="col">MONTO</th>
            <th scope="col">CUOTAS</th>
            <th scope="col">FECHA REGISTRO</th>
          </tr>
        </thead>
        <tbody class="align-middle reducirTamaño">
          <tr
            class="text-nowrap text-center"
            v-for="(itema, index) in ItemsPara"
            :key="index.id"
          >
            <td v-if="idPerfilUsuario == 5" class="text-center">
              <button class="btn btn-outline-warning btn-sm me-2" @click="ModificarDescuento(itema)">
                <i class="bi bi-pencil-fill"></i>
              </button>
              <button v-if="idPerfilUsuario == 5" class="btn btn-outline-danger btn-sm" @click="eliminarDescuento(itema)">
                <i class="bi bi-trash3-fill"></i>
              </button>
            </td>
            <td class="text-center fw-bold text-primary">{{ itema.concepto }}</td>
            <td class="text-start">{{ itema.observacion }}</td>
            <td class="fw-bold">S/ {{ itema.monto }}</td>
            <td>{{ itema.cuota }}</td>
            <td class="small">{{ itema.fechaRegistro.slice(0, 10) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
 
export default {
  name: "SolimanologDescuentoParams",
  data() {
    return {
      Items: [],
      ItemsPara: [],
      paramsTecnologia: [],
      parCodigo: "",
      parDescripcion: "",
      monto: "",
      nombre: "",
      centro: "",
      subCentro: "",
      subSubCentro: "",
      periodo: "",
      documentos: "",
      idEmpresa: "",
      cesCodCc: "",
      cesCodScc: "",
      cesCodSscc: "",
      cuotas: "",
      descripcion: "",
      editar: false,

      cuotasModal: "",
      descripcionModal: "",
      montoModal: "",
      parCodigoModal: "",
      nombreSeleccionado: "",
      idDescuento: "",
      idPerfil: "",
      conceptoIndex: "",
      idPerfilUsuario: "",
    };
  },

  mounted() {
    this.idPerfilUsuario =localStorage.getItem("idPerfil");
    this.idPerfil = parseInt(this.$route.params.idPerfil); // Obtener idPerfil de la ruta y convertir a número
    console.log("idTrabajador:", this.$route.params.id);
    this.axios
      .get(`Cese/Cesexid?idTrabajador=${this.$route.params.id}`)
      .then((r) => {
        console.log('trabajadores',r.data);
        this.Items = r.data;

        this.nombre = this.Items[0].nomTrabajador;
        this.documentos = this.Items[0].nroDocumento;
        this.centro = this.Items[0].nomEmpresa;
        this.subCentro = this.Items[0].subCentroCostos;
        this.subSubCentro = this.Items[0].subSubCentroCostos;
        this.periodo = this.Items[0].periodo;
        this.idEmpresa = this.Items[0].idEmpresa;
        this.cesCodCc = this.Items[0].cesCodCc;
        this.cesCodScc = this.Items[0].cesCodScc;
        this.cesCodSscc = this.Items[0].cesCodSscc;
      });

    if (this.idPerfil == 15) {
      this.axios.get("ParametroData/Parametro/2504").then((r) => {
        console.log(r.data);
        this.paramsTecnologia = r.data;
      });
    }

    if (this.idPerfil == 5) {
      this.axios.get("ParametroData/Parametro/2508").then((r) => {
        console.log(r.data);
        this.paramsTecnologia = r.data;
      });
    }

    if (this.idPerfil == 7) {
      this.axios.get("ParametroData/Parametro/2512").then((r) => {
        console.log(r.data);
        this.paramsTecnologia = r.data;
      });
    }

    if (this.idPerfil == 16) { // Actualizado a 16 para Bienestar según tu solicitud
      this.axios.get("ParametroData/Parametro/2516").then((r) => {
        console.log(r.data);
        this.paramsTecnologia = r.data;
      });
    }

    this.axios
      .get(
        `Cese/Descuentoxid?idTrabajador=${this.$route.params.id}&idPerfil=${this.idPerfil}`
      )
      .then((r) => {
        console.log('tablita abajo',r.data);
        this.ItemsPara = r.data;
      });
  },

  created() {
    this.cambiarEstadoNavbar();
  },

  methods: {
    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },

    limitarDigitos() {
      const maxDigits = 5; // Número máximo de dígitos permitidos
      const maxDigits1 = 2;
      const maxChars = 240;

      // Convierte a string y corta si se excede el número máximo de dígitos
      if (this.monto !== null && this.monto.toString().length > maxDigits) {
        this.monto = parseInt(this.monto.toString().substring(0, maxDigits));
      }

      if (
        this.montoModal !== null &&
        this.montoModal.toString().length > maxDigits
      ) {
        this.montoModal = parseInt(
          this.montoModal.toString().substring(0, maxDigits)
        );
      }

      if (this.cuotas !== null && this.cuotas.toString().length > maxDigits1) {
        this.cuotas = parseInt(this.cuotas.toString().substring(0, maxDigits1));
      }

      if (
        this.cuotasModal !== null &&
        this.cuotasModal.toString().length > maxDigits1
      ) {
        this.cuotasModal = parseInt(
          this.cuotasModal.toString().substring(0, maxDigits1)
        );
      }

      if (this.descripcion.length > maxChars) {
        this.descripcion = this.descripcion.substring(0, maxChars);
      }

      if (this.descripcionModal.length > maxChars) {
        this.descripcionModal = this.descripcionModal.substring(0, maxChars);
      }
    },

    getAttributes() {
      this.axios
        .get(
          `Cese/Descuentoxid?idTrabajador=${this.$route.params.id}&idPerfil=${this.idPerfil}`
        )
        .then((r) => {
          console.log(r.data);
          this.ItemsPara = r.data;
        });
    },

    SelectorOptions() {
      if (this.conceptoIndex !== "") {
        const seleccionado = this.paramsTecnologia[this.conceptoIndex];
        this.parCodigo = seleccionado.parCorrelativo;
        this.parDescripcion = seleccionado.parDescripcion;
        
        console.log(this.parCodigo, this.parDescripcion);
      }
    },

    SelectorOptionsModal(event) {
      this.parCodigoModal =
        this.paramsTecnologia[event.target.value].parCorrelativo;
      console.log(this.parCodigoModal);
    },

    Insertar() {
      const from = {
        idTrabajador: `${this.$route.params.id}`,
        idEmpresa: `${this.idEmpresa}`,
        desCodCc: `${this.cesCodCc}`,
        desCodScc: `${this.cesCodScc}`,
        desCodSscc: `${this.cesCodSscc}`,
        monto: `${this.monto}`,
        idPerfil: `${this.idPerfil}`,
        concepto: `${this.parCodigo}`,
        cuota: `${this.cuotas}`,
        observacion: `${this.descripcion}`,
      };

      console.log(from);

      this.axios.post(`Cese/InsertDescuento`, from).then((r) => {
        console.log(r.data);

        if (r.data) {
          this.getAttributes();
          this.monto = "";
          this.cuotas = "";
          this.descripcion = "";
          this.conceptoIndex = "";
          this.parCodigo = "";
          this.parDescripcion = "";

          Swal.fire({
            position: "center",
            icon: "success",
            title: "SE REGISTRO EL DESCUENTO",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    },

    ModificarDescuento(itema) {
      this.editar = true;

      this.axios
        .get(`Cese/MostrarPersonaxid?idDescuento=${itema.idDescuento}`)
        .then((r) => {
          console.log(r.data);
          this.idDescuento = itema.idDescuento;
          this.nombreSeleccionado = r.data.concepto;
          this.montoModal = r.data.monto;
          this.cuotasModal = r.data.cuota;
          this.descripcionModal = r.data.observacion;
        });
    },

    GuardarModificacion() {
      const from = {
        idDescuento: this.idDescuento,
        monto: `${this.montoModal}`,
        concepto: `${this.parCodigoModal}`,
        cuota: `${this.cuotasModal}`,
        observacion: `${this.descripcionModal}`,
      };
      this.axios.put(`Cese/ModificarDesTecnologia`, from).then((r) => {
        console.log(r);
        if (r.data) {
          this.editar = false;
          Swal.fire({
            position: "center",
            icon: "success",
            title: "SE REALIZO LOS CAMBIOS",
            showConfirmButton: false,
            timer: 2500,
          });

          this.getAttributes();
          console.log(from);
        }
      });
    },

    eliminarDescuento(items) {
      console.log(items.idDescuento);

      Swal.fire({
        title: "¿Estás seguro de eliminar?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "SI",
        cancelButtonText: "CANCELAR",
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios
            .delete(`Cese/Eliminar?idDescuento=${items.idDescuento}`)
            .then((r) => {
              console.log(r.data);
              if (r.data) {
                Swal.fire("Se eliminó correctamente", "", "success");
                this.getAttributes();
              }
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.tituloResaltado {
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}
.reducirTamaño {
  font-size: 0.65rem;
}

.bg-solimano {
  background: #1565C0;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2); /* Fondo más transparente */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  pointer-events: auto; /* Permite eventos de ratón en el modal */
}

.modal-content {
  width: 50%;
  height: auto;
  background-color: #fbfbfb;
  border: 3px rgb(60, 60, 60) solid;
  padding: 0.5%;
}

.tamaño {
  font-size: 0.65rem;
  font-weight: 800;
  color: #002c5d;
}

.color {
  font-weight: 700;
  color: #002c5d;
}
</style>